import React from 'react';

const BarsIcon = () => (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0H18V2H0V0Z" fill="#737373"/>
        <path d="M0 7H18V9H0V7Z" fill="#737373"/>
        <path d="M0 14H18V16H0V14Z" fill="#737373"/>
    </svg>
);

export default BarsIcon;
